import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class IncidentService extends BaseDataService {

    constructor(protected dataService: DataService,  private httpClient: HttpClient) {
        super(dataService, API_URL);
    }
    public ExportXLS(accountId: number, siteId: number, selectedDate: string, selectedEndDate: string, type1Filter: number, type2Filter: number, type3Filter: number, searchText: string) {
        let url = `Incident/ExportXLS?accountId=${accountId}&siteId=${siteId}&selectedDate=${selectedDate}&selectedEndDate=${selectedEndDate}&selectedType1=${type1Filter}&selectedType2=${type2Filter}&selectedType3=${type3Filter}&searchText=${searchText}`;
        return super.savePDF<any>(url, 'application/pdf');
    }

    public DeleteEmail(id: number) {
        let url = `DailyReportRecipient/Delete?id=${id}`;
        return super.getAll<any>(url);
    }
    public GetAllEmailsFiltered(accountId: number, siteId: number, reportType: string) {
        let url = `DailyReportRecipient/GetAll?accountId=${accountId}&siteId=${siteId}&reportType=${reportType}`;
        return super.getAll<any>(url);
    }
    public GetAllEmailsBySiteAndAccount(accountId: number, siteId: number) {
        let url = `DailyReportRecipient/GetAllEmailsBySiteAndAccount?accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }
    public saveEmail(data) {
        let url = `DailyReportRecipient/Save`;
        return super.save<any>(url, data);
    }

    public getEmailLogs(accountId: number, siteId: number, reportType: string ) {
        let url = `Incident/Logs?accountId=${accountId}&siteId=${siteId}&reportType=${reportType}`;
        return super.getAll<any>(url);
    }

    public EnableSchedule(data) {
        let url = `Incident/EnableSchedule`;
        return super.save<any>(url, data);
    }

    public GetAllReportTypes() {
        let url = `DailyReportRecipient/GetAllReportTypes`;
        return super.getAll<any>(url);
    }

    public GetTimezones() {
        let url = `Incident/GetTimezones`;
        return super.getAll<any>(url);
    }

    public SendDailyReport(base64Data) {
        let url = `Incident/SendDailyReport`;
        return super.save<any>(url, base64Data);
    }

    public DownloadReport(routineName, date1data, date2data, siteId) {
        let url = `Incident/DownloadReport?routineName=${routineName}&date1data=${date1data}&date2data=${date2data}&siteId=${siteId}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public getIncidentRange(model: any): Observable<any> {
        let url = `Incident/GetIncidentRange`;
        return super.save<any>(url, model);
    }
    public getAllIncidents(accountId: number, siteId: number, selectedDate: string, selectedEndDate: string, type1Filter: number, type2Filter: number, type3Filter: number, searchText: string): Observable<any> {

        let url = `Incident/GetAll?accountId=${accountId}&siteId=${siteId}&selectedDate=${selectedDate}&selectedEndDate=${selectedEndDate}&selectedType1=${type1Filter}&selectedType2=${type2Filter}&selectedType3=${type3Filter}&searchText=${searchText}&userId=${this.userId}`;
        return super.getAll<any>(url);
    }

    public getMinMaxStatsDate(accountId: number, siteId: number) {
        let url = `Incident/Statistics/Dates?accountId=${accountId}&siteId=${siteId}`
        return super.getAll<any>(url);
    }

    public getStatistics(start: any, end: any, accountId: number, siteId: number, dateType: number, dataType: number) {
        let url = `Incident/Statistics?start=${start}&end=${end}&accountId=${accountId}&siteId=${siteId}&dateType=${dateType}&dataType=${dataType}`
        return super.getAll<any>(url);
    }

    public exportStatistics(model: any) {
        let url = `Incident/Statistics/Export?filter=${JSON.stringify(model)}`
        return super.savePDF<any>(url, 'application/vnd.ms-excel');
    }

    public getGuardsToday(accountId: number, siteId: number, selectedDate: string): Observable<any> {

        let url = `Incident/GetGuardsToday?accountId=${accountId}&siteId=${siteId}&selectedDate=${selectedDate}`;
        return super.getAll<any>(url);
    }

    public getAllSection(siteId: number): Observable<any> {

        let url = `Incident/GetAllSection?siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getIncidentV2(id?: number): Observable<any> {
        let url = `Incident/Get/v2?id=${id}`;
        return super.getAll<any>(url);
    }

    public getIncident(id?: number): Observable<any> {
        let url = `Incident/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveIncident(data: any, fromScan = false) {
        let url = `Incident/Save?fromScan=${fromScan}`;
        return super.save<any>(url, {...data, FromWeb: true });
    }

    public saveIncidentv2(data: FormData, fromScan = false, isRecurring = false) {
        let url = isRecurring ? `${API_URL}/Incident/SaveRcurring` :`${API_URL}/Incident/Save/v2?fromScan=${fromScan}`;
        return this.httpClient.post(url, data)
    }

    public deleteIncident(data, moduleId) {
        let url = `Incident/Delete?id=${data}&moduleId=${moduleId}`;
        return super.save<any>(url, data);
    }

    public GetExcel() {
        let url = `Incident/GetExcel`;
        return super.getAll<any>(url);
    }

    public GetType3ByContanctId(contactId: any) {
        let url = `Incident/GetType3ByContanctId?contactId=${contactId}`;
        return super.getAll<any>(url);
    }

    public GetStatisticsPredefinedFields(category: number, siteId: number) {
        let url = `Incident/Export/Predefined?category=${category}&siteId=${siteId}`
        return super.getAll<any>(url);
    }

    public SaveStatisticsPredefinedFields(data: any) {
        let url = `Incident/Export/Predefined`;
        return super.save<any>(url, data);
    }

    get userId() {
        let currentUser = JSON.parse(localStorage.getItem("currentUser"))
        return currentUser?.id
    }
}



// WEBPACK FOOTER //
// ./src/app/services/incident.service.ts